import { getLeagueLogoUrl } from '../../urls';
import { LEAGUE_NAMES, type ESPNLeagueId } from '../../../shared';
import { LIGHT, STUB, bbox, leagueBuilder, team } from '../builders';
import type { LogoVsLogoLeague } from '../types';

const ID: ESPNLeagueId = 'brasileirao-serie-a';
const { uniform } = leagueBuilder(ID);

const teams = [
  team('athletico-paranaense', 'Athletico Paranaense', uniform('athletico-paranaense', '#F20321', '#000000')),
  team('athletico-mineiro', 'Atlético Mineiro', uniform('athletico-mineiro', LIGHT, '#1F191A')),
  team('bahia', 'Bahia', uniform('bahia', '#006CB9', '#FF2F35')),
  team('botafogo', 'Botafogo', uniform('botafogo', LIGHT, '#000000')),
  team('rb-bragantino', 'Bragantino', uniform('rb-bragantino', STUB, STUB)),
  team('chapecoense', 'Chapecoense', uniform('chapecoense', '#008F2F', LIGHT)),
  team('corinthians', 'Corinthians', uniform('corinthians', '#000000', '#FF162B')),
  team('coritiba', 'Coritiba', uniform('coritiba', '#00544C', LIGHT)),
  team('cruzeiro', 'Cruzeiro', uniform('cruzeiro', '#005AA5', LIGHT)),
  team('flamengo', 'Flamengo', uniform('flamengo', '#ED1C24', LIGHT)),
  team('fluminense', 'Fluminense', uniform('fluminense', '#900028', '#006940')),
  team('gremio', 'Grêmio', uniform('gremio', '#0884BD', LIGHT)),
  team('internacional', 'Internacional', uniform('internacional', '#FF0001', LIGHT)),
  team('mirassol', 'Mirassol', uniform('mirassol', ['#ECBB00', '#003779'], ['#6A001C', '#003779'])),
  team('palmeiras', 'Palmeiras', uniform('palmeiras', '#006431', '#DDDDDD')),
  team('remo', 'Remo', uniform('remo', '#000000', LIGHT)),
  team('santos', 'Santos', uniform('santos', STUB, STUB)),
  team('sao-paulo', 'São Paulo', uniform('sao-paulo', '#FE0000', LIGHT)),
  team('vasco-da-gama', 'Vasco da Gama', uniform('vasco-da-gama', LIGHT, '#000000')),
  team('vitoria', 'Vitória', uniform('vitoria', '#E40613', '#000000'))
];

export const brasileiraoSerieA: LogoVsLogoLeague = {
  value: ID,
  label: LEAGUE_NAMES[ID],
  logo: { src: getLeagueLogoUrl(ID), bbox: bbox(35, 45, 287, 323) },
  teams
};
